import { HeaderTheme } from "./types.ts";
import { FormattedMessage, FormattedNumber } from "react-intl";
import styles from "./StudentAccountBalanceButton.module.scss";
import HeaderButton from "./HeaderButton.tsx";
import { clsx } from "clsx";
import PopoverDisclosure from "../../../../common/core-ui/PopoverDisclosure.tsx";
import { useBrandLoaderData } from "../../../root/rootLoader.ts";
import { useFinAid } from "../../homeContext.ts";
import { Suspense } from "react";
import { Await, useAsyncValue } from "react-router-dom";
import { FinAid } from "../../../../common/api/decimal/methods/user.ts";

function StudentAccountBalanceButtonInner({ theme }: { theme: HeaderTheme }) {
  const brand = useBrandLoaderData();
  const finAid = useAsyncValue() as FinAid;

  if (finAid.balance === 0) {
    return null;
  }

  return (
    <div className={styles.container}>
      <PopoverDisclosure
        placement="bottom"
        yOffset={8}
        renderTrigger={(props) => (
          <HeaderButton
            className={clsx(
              styles.accountButton,
              theme === "accent" && styles.accent,
              theme === "outline" && styles.outline
            )}
            theme={theme}
            {...props}
          >
            {brand.VirtualStore.FinAid.studentAccountBalanceLabel || (
              <FormattedMessage defaultMessage="Student Account Balance" />
            )}
            <span>
              <FormattedNumber
                value={finAid.balance}
                style="currency"
                currency={finAid.currency}
              />
            </span>
          </HeaderButton>
        )}
      >
        <div className={styles.popover}>
          <FormattedMessage defaultMessage="Use this balance during checkout towards the purchase of your course materials." />
        </div>
      </PopoverDisclosure>
    </div>
  );
}

export default function StudentAccountBalanceButton({
  theme,
}: {
  theme?: HeaderTheme;
}) {
  const brand = useBrandLoaderData();
  const finAid = useFinAid();

  if (!brand.VirtualStore.companyId || !brand.VirtualStore.FinAid.enabled) {
    return null;
  }

  return (
    <Suspense>
      <Await resolve={finAid}>
        <StudentAccountBalanceButtonInner theme={theme} />
      </Await>
    </Suspense>
  );
}
